__turbopack_context__.v({
  "Player": "_1YoiFW_Player",
  "Player--Card": "_1YoiFW_Player--Card",
  "Player__Button": "_1YoiFW_Player__Button",
  "Player__Button--Card": "_1YoiFW_Player__Button--Card",
  "Player__Controls": "_1YoiFW_Player__Controls",
  "Player__Loading": "_1YoiFW_Player__Loading",
  "Player__Seek": "_1YoiFW_Player__Seek",
  "Player__SeekInput": "_1YoiFW_Player__SeekInput",
  "Player__Time": "_1YoiFW_Player__Time",
});
